import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Flex,
    Text,
    Image,
    UnorderedList,
    ListItem,
    Link,
    List,
    ListIcon,
    Show,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    useDisclosure,
    Grid,
} from '@chakra-ui/react';
import FAQ from '../../sections/Faq/Faq';
import ChakraTilesSection from '../../sections/ChakraTilesSection/ChakraTilesSection';
import WhyService from '../../sections/WhyService/WhyService';
import BenefitsSectionWithImage from '../../sections/BenefitsSectionWithImage/BenefitsSectionWithImage';
import ExtendedTabsSection from '../../sections/ExtendedTabsSection/ExtendedTabsSection';
import { CheckIcon } from '@chakra-ui/icons';
import { ButtonContainer } from '../../sections/MigrationSection/styles';
import StyledButton from '../../components/Button/Button';
import ContactSection from '../../sections/ContactSection/ContactSection';
import ContentImage from '../../sections/ContentImageSection/ContentImageSection';
import FormSection from '../../sections/FormSection/FormSection';
import { useEffect, useState } from 'react';

interface Props {}

enum AppType {
    Windows = 'windows',
    Mac = 'mac',
    Online = 'online',
    Panel = 'panel',
    All = 'all',
}

interface image {
    url: string;
    alt: string;
}
interface App {
    id: number;
    title: string;
    description: string;
    app_type: string[];
    image: image;
    images?: image[];
    price: {
        value: string;
        adding: string;
    };
    longDescription?: JSX.Element;
    type: string;
    license: string;
}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=589698&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - aplikacje idosell',
};

const apps = [
    {
        id: 1,
        title: 'Dropui.com',
        description:
            'Dropui.com to interaktywne i skuteczne pop-upy, paski oraz elementy osadzone w Twoim sklepie internetowym.',
        app_type: [AppType.Windows],
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=590662&ext=.png',
            alt: 'Zdjęcie główne w DropUI',
        },
        images: [
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592274&ext=.png',
                alt: 'DropUI 1',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592275&ext=.png',
                alt: 'DropUI 2',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592276&ext=.png',
                alt: 'DropUI 3',
            },
        ],
        longDescription: (
            <>
                <Text>
                    Twórz interaktywne elementy na stronie bez potrzeby programowania: zniżki,
                    kupony, rekomendacje produktów czy ankiety. Zbieraj dane klientów i analizuj
                    efektywność kampanii dzięki łatwym w obsłudze narzędziom.
                </Text>
                <Text>
                    Dropui.com to wszechstronne rozwiązanie dla e-commerce - już ponad 6000
                    integracji, używanych w 27 krajach.
                </Text>
            </>
        ),
        price: { value: 'od 49,00 zł', adding: 'netto/mc' },
        type: 'Aplikacja online',
        license: 'Licencja dotyczy wielu instalacji aplikacji',
    },
    {
        id: 2,
        title: 'Share Basket',
        description:
            'Share Basket to narzędzie, które umożliwia łatwe udostępnianie koszyka zakupowego za pomocą wygenerowanego linku bez konieczności logowania.',
        app_type: [AppType.Online],
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=590663&ext=.png',
            alt: 'Zdjęcie główne w Share Basket',
        },
        images: [
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592317&ext=.png',
                alt: 'Share Basket - zdjęcie poglądowe 1',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592318&ext=.png',
                alt: 'Share Basket - zdjęcie poglądowe 2',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592319&ext=.png',
                alt: 'Share Basket - zdjęcie poglądowe 3',
            },
        ],
        longDescription: (
            <>
                <Text>
                    <Text as={'span'} fontWeight={'700'}>
                        Udostępniaj swój koszyk jednym kliknięciem!
                    </Text>{' '}
                    Nowe narzędzie w IdoSell pozwoli Twoim klientom łatwo udostępniać zawartość
                    koszyka zakupowego za pomocą linku. Wystawczy zapisać koszyk, skopiować link i
                    można wrócić do niego w dowolnym momencie na różnych urządzeniach – bez
                    logowania. Dzięki temu klienci mogą łatwo udostępnić koszyk znajomym lub
                    rodzinie, żeby wspólnie finalizować zakupy.
                </Text>
            </>
        ),
        price: { value: 'od 69,00 zł', adding: 'netto/mc' },
        type: 'Aplikacja online',
        license: 'Licencja dotyczy wielu instalacji aplikacji',
    },
    {
        id: 3,
        title: 'Hodafy',
        description:
            'Hodafy - platforma dla sprzedawców Allegro oferująca pełne statystyki rentowności i kontrolę kosztów dla Twoich ofert oraz optymalizację sprzedaży.',
        app_type: [AppType.Online],
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=590664&ext=.png',
            alt: 'Zdjęcie główne w Hodafy',
        },
        longDescription: (
            <>
                <Text>
                    Hodafy to zaawansowana platforma dla sprzedawców Allegro, która pomaga
                    kontrolować sprzedaż, analizować koszty i maksymalizować zyski. Dzięki
                    integracji z IdoSell Twoje aukcje będą automatycznie synchronizowane, co pozwoli
                    oszczędzić czas i skoncentrować się na rozwoju biznesu.
                </Text>
                <Text>
                    Integracja z panelem IdoSell umożliwia automatyczne pobieranie cen hurtowych
                    oraz natychmiastowy dostęp do wyników sprzedaży.
                </Text>
            </>
        ),
        images: [
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592323&ext=.png',
                alt: 'Hodafy - zdjęcie poglądowe 1',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592324&ext=.png',
                alt: 'Hodafy - zdjęcie poglądowe 2',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592325&ext=.png',
                alt: 'Hodafy - zdjęcie poglądowe 3',
            },
        ],
        price: { value: '49,00 zł', adding: 'netto/mc' },
        type: 'Aplikacja online',
        license: 'Licencja dotyczy wielu instalacji aplikacji',
    },
    {
        id: 4,
        title: 'Generator Opisów z ChatGPT',
        description: 'Generuj opisy produktów i opisy menu za pomocą sztucznej inteligencji.',
        app_type: [AppType.Online],
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=590665&ext=.png',
            alt: 'Zdjęcie główne w Generator Opisów z ChatGPT',
        },
        images: [
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592354&ext=.png',
                alt: 'Zdjęcie generator opisów z chatGPT',
            },
        ],
        longDescription: (
            <>
                <Text>
                    Aplikacja pozwala na masowe generowanie i optymalizację treści dla produktów i
                    menu przy użyciu sztucznej inteligencji (ChatGPT). Użytkownik sam definiuje
                    polecenia, dzięki czemu możliwości są niemal nieograniczone – od tworzenia
                    opisów produktów, przez optymalizację SEO, po poprawę błędów i edycję treści z
                    zachowaniem układu HTML.
                </Text>
                <Text>
                    Aplikacja działa na wybranych lub wszystkich towarach i menu, a jej obsługa nie
                    wymaga umiejętności technicznych.
                </Text>
            </>
        ),
        price: { value: '299,00 zł', adding: 'netto/mc' },
        type: 'Aplikacja online',
        license: 'Licencja dotyczy wielu instalacji aplikacji',
    },
    {
        id: 5,
        title: 'TrustMate',
        description:
            'Wyższa konwersja dzięki długim opiniom. Z TrustMate zbierzesz opinie nawet 10x dłuższe i bardziej szczegółowe niż standardowe!',
        app_type: [AppType.Online],
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=590666&ext=.png',
            alt: 'Zdjęcie główne w TrustMate',
        },
        images: [
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592355&ext=.png',
                alt: 'Zdjęcie Trustmate',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592356&ext=.png',
                alt: 'Zdjęcie Trustmate 2',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592357&ext=.png',
                alt: 'Zdjęcie Trustmate 3',
            },
        ],
        price: { value: 'Za darmo', adding: 'netto/mc' },
        longDescription: (
            <>
                <Text>
                    Dzięki unikalnemu systemowi podpowiedzi, TrustMate pozwala pozyskiwać aż 10 razy
                    dłuższe i bardziej szczegółowe opinie, wzbogacone o słowa kluczowe i zdjęcia,
                    które podnoszą Twoją pozycję w Google. Integracja z Google Shopping i widoczne
                    gwiazdki w wynikach wyszukiwania generują do 40% więcej ruchu.
                </Text>
                <Text>
                    Mechanizm mediacji zmniejsza liczbę negatywnych recenzji nawet o 60%, a
                    automatyczne tłumaczenia ułatwiają prezentację opinii na nowych rynkach.
                    Wystarczy kilka prostych kroków, by TrustMate zaczęło działać na rzecz Twojej
                    sprzedaży i widoczności!
                </Text>
            </>
        ),
        type: 'Aplikacja online',
        license: 'Licencja dotyczy wielu instalacji aplikacji',
    },
    {
        id: 6,
        title: 'ClickScanner',
        description:
            'Nie płać za wyklikiwanie reklam w Google i Facebook przez niezainteresowanych klikaczy, konkurencję lub boty.',
        app_type: [AppType.Online],
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=590667&ext=.png',
            alt: 'Zdjęcie główne w ClickScanner',
        },
        images: [
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592358&ext=.png',
                alt: 'Zdjęcie ClickScanner 1',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592359&ext=.png',
                alt: 'Zdjęcie ClickScanner 2',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592360&ext=.png',
                alt: 'Zdjęcie ClickScanner 3',
            },
        ],
        longDescription: (
            <>
                <Text>
                    Nie trać budżetu na wyklikiwanie reklam przez boty, konkurencję lub
                    niezainteresowanych użytkowników. Dzięki technologii ClickScanner wykrywa i
                    blokuje:
                </Text>
                <List>
                    <ListItem>Kliknięcia od botów</ListItem>
                    <ListItem>Wyklikiwanie przez konkurencję</ListItem>
                    <ListItem>Kliki z egzotycznych lokalizacji</ListItem>
                    <ListItem>Taśmowe klikanie z tych samych urządzeń</ListItem>
                    <ListItem>Ruch od użytkowników bez intencji zakupowej</ListItem>
                </List>
                <Text>
                    Dzięki ClickScanner Twoje reklamy dotrą do realnych klientów, co poprawi
                    konwersję i wyniki sprzedaży. Aplikacja integruje się z Google Ads i
                    Facebookiem, działa na każdej platformie sklepowej, a jej instalacja jest szybka
                    i prosta.
                </Text>
                <Text>
                    Chroń swoje kampanie i maksymalizuj efekty reklamowe dzięki ClickScanner – bez
                    długoterminowych zobowiązań!
                </Text>
            </>
        ),
        price: { value: 'od 300,00 zł', adding: 'netto/mc' },
        type: 'Aplikacja online',
        license: 'Licencja dotyczy wielu instalacji aplikacji ',
    },
    {
        id: 7,
        title: 'IdoSell POS',
        description:
            'IdoSell POS to system kasowy dla sklepów, który automatycznie przesyła dane sprzedaży do panelu IdoSell, działa offline i obsługuje wiele stanowisk.',
        app_type: [AppType.Windows],
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=590668&ext=.png',
            alt: 'Zdjęcie główne w IdoSell POS',
        },
        images: [
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592361&ext=.png',
                alt: 'Zdjęcie IdoSell POS 1',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592362&ext=.png',
                alt: 'Zdjęcie IdoSell POS 2',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592363&ext=.png',
                alt: 'Zdjęcie IdoSell POS 3',
            },
        ],
        price: { value: 'od 59,00 zł', adding: 'netto/mc' },
        longDescription: (
            <>
                <Text>
                    IdoSell POS automatycznie synchronizuje stany magazynowe i dane sprzedażowe z
                    panelem administracyjnym IdoSell, umożliwiając prowadzenie spójnej sprzedaży
                    omnichannel.
                </Text>
                <Text>
                    System działa na Windows i obejmuje aplikacje Server, Setup i Klient. Dzięki
                    pracy offline i obsłudze wielu stanowisk kasowych, sprawdzi się w każdej
                    placówce. IdoSell POS współpracuje z drukarkami fiskalnymi, czytnikami kodów,
                    szufladami kasowymi i terminalami płatniczymi, a najlepsze doświadczenie
                    zapewnia terminal z ekranem dotykowym.
                </Text>
            </>
        ),
        type: 'Aplikacja offline',
        license: 'Licencja dotyczy wielu instalacji aplikacji',
    },
    {
        id: 8,
        title: 'IdoSell Downloader',
        description:
            'IdoSell Downloader to aplikacja, która umożliwia importowanie i aktualizowanie ofert od różnych dostawców, łącząc Twój sklep z hurtownią.',
        app_type: [AppType.Windows],
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=590669&ext=.png',
            alt: 'Zdjęcie główne w IdoSell Downloader',
        },
        images: [
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592364&ext=.png',
                alt: 'Zdjęcie IdoSell Downloader 1',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592365&ext=.png',
                alt: 'Zdjęcie IdoSell Downloader 2',
            },
            {
                url: 'https://www.idosell.com/panel/file-gate.php?id=592366&ext=.png',
                alt: 'Zdjęcie IdoSell Downloader 3',
            },
        ],
        longDescription: (
            <>
                <Text>
                    <Text as={'span'} fontWeight={'700'}>
                        IdoSell Downloader
                    </Text>{' '}
                    to narzędzie, które automatyzuje import i aktualizację oferty produktowej w
                    sklepach internetowych. Umożliwia szybkie pobieranie danych od dostawców (XML,
                    CSV) i integrację ich ze sklepem, eliminując potrzebę ręcznego wprowadzania
                    informacji.
                </Text>
                <Text>
                    Dzięki obsłudze wielu dostawców, aplikacja pozwala na bieżąco aktualizować stany
                    magazynowe, ceny i dostępność produktów, zapewniając spójność danych. To idealne
                    rozwiązanie dla sklepów współpracujących z hurtowniami, które chcą oszczędzić
                    czas i zwiększyć efektywność zarządzania asortymentem.
                </Text>
            </>
        ),
        price: { value: 'od 99,00 zł', adding: 'netto/mc' },
        type: 'Aplikacja online',
        license: 'Licencja dotyczy wielu instalacji aplikacji  ',
    },
    {
        id: 9,
        title: 'Ecomail.pl',
        description:
            'Ecomail.pl to narzędzie marketingowe umożliwiające wysyłkę newsletterów i SMS-ów, automatyzację e-mailingu oraz skuteczne zarządzanie bazą kontaktów.',
        app_type: [AppType.Panel],
        image: {
            url: 'https://apps.idosell.com/files/applications/37/e942b41b0c3d6a39aa3801ef2a759e03.png',
            alt: 'Zdjęcie główne Ecomail.pl',
        },
        images: [
            {
                url: 'https://apps.idosell.com/files/applications/37/15469ad8a0e5096ff336c86ff536b48e.png',
                alt: 'Zdjęcie aplikacji IdoSell Ecomail.pl 1',
            },
            {
                url: 'https://apps.idosell.com/files/applications/37/8199d13aa39229ae25af707eedf5e25a.png',
                alt: 'Zdjęcie aplikacji IdoSell Ecomail.pl 2',
            },
            {
                url: 'https://apps.idosell.com/files/applications/37/a24e9b1311c736343f1720802d0a3432.png',
                alt: 'Zdjęcie aplikacji IdoSell Ecomail.pl 3',
            },
        ],
        longDescription: (
            <>
                <Text>
                    <Text as={'span'} fontWeight={'700'}>
                        Ecomail.pl
                    </Text>{' '}
                    to narzędzie marketingowe umożliwiające wysyłkę newsletterów i SMS-ów,
                    automatyzację e-mailingu oraz skuteczne zarządzanie bazą kontaktów.
                </Text>
                <Text>
                    Zwiększ sprzedaż dzięki integracji z Ecomail.pl. Synchronizuj dane w czasie
                    rzeczywistym, wysyłaj newslettery i automatyzuj e-mailing, żeby dotrzeć do
                    klientów we właściwym momencie. Ecomail to intuicyjna platforma, która dzięki
                    automatyzacji, personalizacji i segmentacji pozwala na skuteczną komunikację z
                    odbiorcami. Monitoruj aktywność użytkowników, reaguj na porzucone koszyki i
                    wysyłaj spersonalizowane wiadomości. Automatyczna synchronizacja kontaktów,
                    zamówień i etykiet oraz szczegółowe raporty pomogą Ci lepiej zarządzać
                    kampaniami.
                </Text>
            </>
        ),
        price: { value: 'Od 35 zł', adding: 'netto/mc' },
        type: 'Aplikacja online',
        license: 'Licencja dotyczy wielu instalacji aplikacji  ',
    },
    {
        id: 9,
        title: 'Szpiegomat.pl',
        description:
            'Szpiegomat.pl to narzędzie do monitoringu cen i automatyzacji cen (repricingu) dla e-commerce. Dzięki niemu możesz śledzić konkurencję, dynamicznie dostosowywać ceny i maksymalizować zyski.',
        app_type: [AppType.Panel],
        image: {
            url: 'https://apps.idosell.com/files/applications/81/000254f8bce73d80de877377b821393b.png',
            alt: 'Zdjęcie główne Szpiegomat',
        },
        images: [
            {
                url: 'https://apps.idosell.com/files/applications/81/02b049332dfc986e92411b6ca97f4e61.jpg',
                alt: 'Zdjęcie aplikacji IdoSell Szpiegomat 1',
            },
            {
                url: 'https://apps.idosell.com/files/applications/81/c55fe2d6c77287a77fb1dd00829b3519.jpg',
                alt: 'Zdjęcie aplikacji IdoSell Szpiegomat 2',
            },
            {
                url: 'https://apps.idosell.com/files/applications/81/e23a78385f8f65eb797064b6cabb2da3.jpg',
                alt: 'Zdjęcie aplikacji IdoSell Szpiegomat 3',
            },
        ],
        longDescription: (
            <>
                <Text>
                    <Text as={'span'} fontWeight={'700'}>
                        Szpiegomat.pl
                    </Text>{' '}
                    to narzędzie do monitoringu cen i automatyzacji (repricingu) dla sklepów
                    internetowych. Śledź konkurencję, dynamicznie dostosowuj ceny i maksymalizuj
                    zyski dzięki inteligentnej analizie rynku.
                </Text>
                <Text>
                    Dzięki Szpiegomat.pl będziesz automatycznie reagować na zmiany cen,
                    optymalizować marże i zwiększać sprzedaż. Monitoruj marketplace’y i strony
                    konkurencji zarówno w Polsce, jak i za granicą, a szczegółowe raporty pomogą Ci
                    podejmować lepsze decyzje biznesowe. Integracja umożliwia automatyczną wymianę
                    danych o cenach, dostępności i asortymencie i wspiera Dynamic Pricing.
                </Text>
            </>
        ),
        price: { value: 'Od 499 zł', adding: 'netto/mc' },
        type: 'Aplikacja w panelu',
        license: 'Licencja dotyczy wielu instalacji aplikacji',
    },
    {
        id: 10,
        title: 'eSprzedawca AI',
        description:
            'eSprzedawca to AI chat, który samodzielnie obsługuje klientów sklepów internetowych, prowadzi rozmowy i sprzedaje 24/7. Wypróbuj go za darmo przez 30 dni i przekonaj się o jego skuteczności.',
        app_type: [AppType.Panel],
        image: {
            url: 'https://apps.idosell.com/files/applications/209/2ea096b463e4ab3b8551629b600ab6d7.png',
            alt: 'Zdjęcie główne eSprzedawca AI',
        },
        images: [
            {
                url: 'https://apps.idosell.com/files/applications/209/aea8e3673f22c714276d569064fe6e42.png',
                alt: 'Zdjęcie aplikacji IdoSell eSprzedawca AI 1',
            },
            {
                url: 'https://apps.idosell.com/files/applications/209/476912383ba815b5ccd8c32881134a18.png',
                alt: 'Zdjęcie aplikacji IdoSell eSprzedawca AI 2',
            },
            {
                url: 'https://apps.idosell.com/files/applications/209/525d2b96e860bc8e9a0396c9ab3bfbdb.png',
                alt: 'Zdjęcie aplikacji IdoSell eSprzedawca AI 3',
            },
        ],
        longDescription: (
            <>
                <Text>
                    <Text as={'span'} fontWeight={'700'}>
                        eSprzedawca AI
                    </Text>{' '}
                    to zaawansowany chatbot sprzedażowy dla e-sklepów, który automatyzuje obsługę
                    klienta i zwiększa sprzedaż 24/7.
                </Text>
                <Text>
                    eSprzedawca AI sam poleca produkty, oferuje rabaty, odpowiada na pytania i
                    generuje raporty sprzedaży. Średnio 15% rozmów kończy się zakupem, a
                    automatyzacja zmniejsza koszty obsługi. Testuj za darmo przez 30 dni z limitem
                    100 rozmów, a potem wybierz plan od 300 PLN miesięcznie. Integracja z Google
                    Merchant Center i możliwością rozszerzenia bazy wiedzy sprawia, że chatbot
                    efektywnie wspiera klientów i optymalizuje sprzedaż.
                </Text>
            </>
        ),
        price: { value: 'od 300 zł', adding: 'netto/mc' },
        type: 'Aplikacja w panelu',
        license: 'Licencja dotyczy wielu instalacji aplikacji',
    },
    {
        id: 11,
        title: 'Erbeo',
        description:
            'Szybkie finansowanie do 250 tys. PLN bez formalności, dostępne bezpośrednio w panelu IdoSell. ',
        app_type: [AppType.Panel],
        image: {
            url: 'https://apps.idosell.com/files/applications/98/67950aea031842c2af010affbbc22a2e.jpg',
            alt: 'Zdjęcie główne Erbeo',
        },
        images: [
            {
                url: 'https://apps.idosell.com/files/applications/98/082cc42f8f1b003cd47027888c0c746f.png',
                alt: 'Zdjęcie aplikacji IdoSell Erbeo 1',
            },
            {
                url: 'https://apps.idosell.com/files/applications/98/59beeba7c2f852b7a83a2e19d159966f.png',
                alt: 'Zdjęcie aplikacji IdoSell Erbeo 2',
            },
            {
                url: 'https://apps.idosell.com/files/applications/98/b36c75b76552ce3f27077146677ba463.png',
                alt: 'Zdjęcie aplikacji IdoSell Erbeo 3',
            },
        ],
        longDescription: (
            <>
                <Text>
                    Dzięki wtyczce Erbeo w panelu IdoSell możesz szybko uzyskać finansowanie na
                    bieżące potrzeby Twojej działalności gospodarczej. Erbeo oferuje kwotę
                    finansowania od 10.000 PLN do 250.000 PLN oraz elastyczny okres spłaty od 3 do
                    12 miesięcy w równych ratach. Środki możesz przeznaczyć na zakup towarów,
                    marketing, wynagrodzenia lub inne cele. Złożenie wniosku online zajmie około 10
                    minut. Decyzję uzyskasz bez zbędnych formalności, a wypłatę środków otrzymasz w
                    ciągu 24 godzin. Zainstaluj wtyczkę w panelu administracyjnym IdoSell, aktywuj
                    konto Erbeo i rozpocznij proces finansowania już teraz.
                </Text>
            </>
        ),
        price: { value: 'Za darmo', adding: 'netto/mc' },
        type: 'Aplikacja w panelu',
        license: 'Licencja dotyczy wielu instalacji aplikacji',
    },
    // {
    //     id: 9,
    //     title: 'IdoSell ERP Exporter',
    //     description:
    //         'IdoSell ERP Exporter to darmowa aplikacja do pobierania dokumentów z panelu administracyjnego IdoSell w formacie EDI++ (EPP). ',
    //     app_type: [AppType.All],
    //     image: {
    //         url: 'https://www.idosell.com/panel/file-gate.php?id=590669&ext=.png',
    //         alt: 'Zdjęcie główne w IdoSell Downloader',
    //     },
    //     images: [
    //         {
    //             url: 'https://www.idosell.com/panel/file-gate.php?id=592364&ext=.png',
    //             alt: 'Zdjęcie IdoSell Downloader 1',
    //         },
    //         {
    //             url: 'https://www.idosell.com/panel/file-gate.php?id=592365&ext=.png',
    //             alt: 'Zdjęcie IdoSell Downloader 2',
    //         },
    //         {
    //             url: 'https://www.idosell.com/panel/file-gate.php?id=592366&ext=.png',
    //             alt: 'Zdjęcie IdoSell Downloader 3',
    //         },
    //     ],
    //     longDescription: (
    //         <>
    //             <Text>
    //                 <Text as={'span'} fontWeight={'700'}>
    //                     IdoSell ERP Exporter
    //                 </Text>{' '}
    //                 pozwala na łatwy import dokumentów magazynowych, sprzedaży oraz płatności z
    //                 panelu IdoSell do programów księgowych lub sprzedażowo-magazynowych. Aplikacja
    //                 automatyzuje i przyspiesza przepływ dokumentów.
    //             </Text>
    //         </>
    //     ),
    //     price: { value: 'od 99,00 zł', adding: 'netto/mc' },
    //     type: 'Aplikacja online',
    //     license: 'Licencja dotyczy wielu instalacji aplikacji  ',
    // },
    // {
    //     id: 9,
    //     title: 'IdoSell cos',
    //     description:
    //         'IdoSell Downloader to aplikacja, która umożliwia importowanie i aktualizowanie ofert od różnych dostawców, łącząc Twój sklep z hurtownią.',
    //     app_type: [AppType.Windows],
    //     image: {
    //         url: 'https://www.idosell.com/panel/file-gate.php?id=590669&ext=.png',
    //         alt: 'Zdjęcie główne w IdoSell Downloader',
    //     },
    //     images: [
    //         {
    //             url: 'https://www.idosell.com/panel/file-gate.php?id=592364&ext=.png',
    //             alt: 'Zdjęcie IdoSell Downloader 1',
    //         },
    //         {
    //             url: 'https://www.idosell.com/panel/file-gate.php?id=592365&ext=.png',
    //             alt: 'Zdjęcie IdoSell Downloader 2',
    //         },
    //         {
    //             url: 'https://www.idosell.com/panel/file-gate.php?id=592366&ext=.png',
    //             alt: 'Zdjęcie IdoSell Downloader 3',
    //         },
    //     ],
    //     longDescription: (
    //         <>
    //             <Text>
    //                 <Text as={'span'} fontWeight={'700'}>
    //                     IdoSell Downloader
    //                 </Text>{' '}
    //                 to narzędzie, które automatyzuje import i aktualizację oferty produktowej w
    //                 sklepach internetowych. Umożliwia szybkie pobieranie danych od dostawców (XML,
    //                 CSV) i integrację ich ze sklepem, eliminując potrzebę ręcznego wprowadzania
    //                 informacji.
    //             </Text>
    //             <Text>
    //                 Dzięki obsłudze wielu dostawców, aplikacja pozwala na bieżąco aktualizować stany
    //                 magazynowe, ceny i dostępność produktów, zapewniając spójność danych. To idealne
    //                 rozwiązanie dla sklepów współpracujących z hurtowniami, które chcą oszczędzić
    //                 czas i zwiększyć efektywność zarządzania asortymentem.
    //             </Text>
    //         </>
    //     ),
    //     price: { value: 'od 99,00 zł', adding: 'netto/mc' },
    //     type: 'Aplikacja online',
    //     license: 'Licencja dotyczy wielu instalacji aplikacji  ',
    // },
    // {
    //     id: 9,
    //     title: 'IdoSell cos',
    //     description:
    //         'IdoSell Downloader to aplikacja, która umożliwia importowanie i aktualizowanie ofert od różnych dostawców, łącząc Twój sklep z hurtownią.',
    //     app_type: [AppType.Windows],
    //     image: {
    //         url: 'https://www.idosell.com/panel/file-gate.php?id=590669&ext=.png',
    //         alt: 'Zdjęcie główne w IdoSell Downloader',
    //     },
    //     images: [
    //         {
    //             url: 'https://www.idosell.com/panel/file-gate.php?id=592364&ext=.png',
    //             alt: 'Zdjęcie IdoSell Downloader 1',
    //         },
    //         {
    //             url: 'https://www.idosell.com/panel/file-gate.php?id=592365&ext=.png',
    //             alt: 'Zdjęcie IdoSell Downloader 2',
    //         },
    //         {
    //             url: 'https://www.idosell.com/panel/file-gate.php?id=592366&ext=.png',
    //             alt: 'Zdjęcie IdoSell Downloader 3',
    //         },
    //     ],
    //     longDescription: (
    //         <>
    //             <Text>
    //                 <Text as={'span'} fontWeight={'700'}>
    //                     IdoSell Downloader
    //                 </Text>{' '}
    //                 to narzędzie, które automatyzuje import i aktualizację oferty produktowej w
    //                 sklepach internetowych. Umożliwia szybkie pobieranie danych od dostawców (XML,
    //                 CSV) i integrację ich ze sklepem, eliminując potrzebę ręcznego wprowadzania
    //                 informacji.
    //             </Text>
    //             <Text>
    //                 Dzięki obsłudze wielu dostawców, aplikacja pozwala na bieżąco aktualizować stany
    //                 magazynowe, ceny i dostępność produktów, zapewniając spójność danych. To idealne
    //                 rozwiązanie dla sklepów współpracujących z hurtowniami, które chcą oszczędzić
    //                 czas i zwiększyć efektywność zarządzania asortymentem.
    //             </Text>
    //         </>
    //     ),
    //     price: { value: 'od 99,00 zł', adding: 'netto/mc' },
    //     type: 'Aplikacja online',
    //     license: 'Licencja dotyczy wielu instalacji aplikacji  ',
    // },
];

export default function AppsPage(props: Props) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedProduct, setSelectedProduct] = useState<App | null>(null);
    const [activeTab, setActiveTab] = useState('Dla sprzedawców'); // Domyślna zakładka

    const handleBoxClick = (app: App) => {
        console.log(selectedProduct);
        setSelectedProduct(app);
        onOpen();
    };

    const [showAll, setShowAll] = useState(false);

    const toggleShowAll = () => setShowAll(!showAll);

    const displayedApps = showAll ? apps : apps.slice(0, 8);

    // Obsługa fragmentu URL (#developers)
    useEffect(() => {
        const hash = window.location.hash;
        if (hash === '#developers') {
            setActiveTab('Dla deweloperów');
            // const element = document.querySelector('#tabs_section');
            // element?.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    const handleTabChange = (tabName: string) => {
        setActiveTab(tabName);
    };

    const renderAppTypeIcon = (appType: string) => {
        switch (appType) {
            case 'windows':
                return (
                    <Box display="flex" alignItems="center">
                        <svg
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_10746_26312)">
                                <path
                                    d="M6.47307 2.25856L1.71875 3.20714V7.59572L6.47304 7.51571L6.47307 2.25856ZM15.2823 8.63214L7.56092 8.49998V13.9578L15.2823 15.5V8.63214ZM6.47307 8.48359L1.71878 8.40286V12.7907L6.47307 13.74V8.48359ZM15.2823 0.5L7.56092 2.04071V7.49856L15.2823 7.36713V0.5Z"
                                    fill="#1C1B22"
                                />
                            </g>
                        </svg>
                        <Text marginLeft="8px">Windows</Text>
                    </Box>
                );
            case 'mac':
                return (
                    <Box display="flex" alignItems="center">
                        <svg
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g>
                                <path
                                    d="M8 0C5.239 0 3 2.239 3 5C3 7.761 5.239 10 8 10C10.761 10 13 7.761 13 5C13 2.239 10.761 0 8 0ZM3.5 12C1.57 12 0 13.57 0 15.5H16C16 13.57 14.43 12 12.5 12H3.5Z"
                                    fill="#1C1B22"
                                />
                            </g>
                        </svg>
                        <Text marginLeft="8px">MacOS</Text>
                    </Box>
                );
            case 'panel':
                return (
                    <Box display="flex" alignItems="center">
                        <Text>Aplikacja w panelu</Text>
                    </Box>
                );
            case 'online':
                return (
                    <Box display="flex" alignItems="center">
                        <Text>Aplikacja online</Text>
                    </Box>
                );
            case 'all':
                return (
                    <Box display="flex" alignItems="center">
                        <Text>
                            Działa na każdym systemie operacyjnym (Windows, MacOS, Linux),
                            oszczędzając czas i pieniądze, szczególnie w przypadku dużych sklepów
                            internetowych.
                        </Text>
                    </Box>
                );
            default:
                return <Text>Nieznany system</Text>; // Domyślny tekst
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="IdoSell Apps - aplikacje dla sklepów"
                subTitle="IdoSell Apps to nowoczesna platforma, 
która oferuje narzędzia i aplikacje wspierające efektywne zarządzanie sklepem internetowym, automatyzację procesów 
oraz integrację z zewnętrznymi rozwiązaniami."
                image={heroImage}
                badgeLabel="NOWOŚĆ"
                paddingDesktop="75px 0"
                gap="0"
                ratio="3/4"
                buttons={[
                    {
                        title: 'Lista dostępnych aplikacji',
                        href: '#apps_container',
                        variant: 'default',
                    },
                ]}
            />
            <div className="homepage containerIdosellPages">
                <ContentImage
                    title="Jak działa IdoSell Apps?"
                    image={{
                        url: 'https://www.idosell.com/panel/file-gate.php?id=589844&ext=.png',
                        alt: 'Infografika ze statystykami idosell',
                    }}
                    layout_order="image_right"
                    padding={'2rem 0 3rem 0'}
                    paddingBottom={{ base: '0' }}
                    bgColor="grey"
                    mt={10}
                    // pt={{
                    //     base: 10,
                    //     lg: 8,
                    // }}
                >
                    <>
                        <p>
                            Jedną z ważniejszych przewag IdoSell Apps nad konkurencyjnymi
                            platformami jest możliwość zastosowania elastycznego modelu rozliczeń za
                            aplikacje. 
                        </p>
                        <p>
                            Dostęp do IdoSell Apps dla merchantów jest bezpłatny, natomiast koszty
                            są naliczane osobno za każdą uruchomioną aplikację, na zasadzie
                            subskrypcji miesięcznej. Cena aplikacji jest ustalana przez jej
                            dewelopera, co umożliwia zróżnicowane oferty dostosowane do potrzeb
                            sklepów internetowych. Dodatkowo, możliwość darmowego testowania
                            aplikacji, minimalizuje ryzyko związane z inwestycjami w nowe narzędzia.
                        </p>
                    </>
                </ContentImage>
                <Box
                    py={{ base: '0', md: '0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                    id="tabs_section"
                >
                    <ExtendedTabsSection
                        styles="centeredWithSpace"
                        tabsContent={[
                            {
                                tabName: 'Dla sprzedawców',
                                content: (
                                    <Box>
                                        <Box
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column', lg: 'row' }}
                                        >
                                            <Box>
                                                <Show above="md">
                                                    <Image
                                                        src="https://www.idosell.com/panel/file-gate.php?id=589948&ext=.png"
                                                        alt=""
                                                    ></Image>
                                                </Show>
                                                <Show below="md">
                                                    <Image
                                                        src="https://www.idosell.com/panel/file-gate.php?id=590735&ext=.png"
                                                        alt=""
                                                    ></Image>
                                                </Show>
                                            </Box>
                                            <Box flex="1" padding={'30ox'}>
                                                <Text
                                                    fontSize={'21px'}
                                                    lineHeight={'1.5'}
                                                    fontWeight={'600'}
                                                    color={'#171717'}
                                                    mb="30px"
                                                >
                                                    Dzięki IdoSell Apps masz dostęp do aplikacji,
                                                    które usprawniają działanie sklepu
                                                    internetowego. Najważniejsze korzyści IdoSell
                                                    Apps to:
                                                </Text>
                                                <List
                                                    spacing={'15px'}
                                                    fontSize={'18px'}
                                                    lineHeight={'27px'}
                                                    color={'#171717'}
                                                >
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                color={''}
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Personalizacja funkcji sklepu
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Dzięki integracji aplikacji z
                                                                panelem IdoSell zyskujesz możliwość
                                                                dostosowania sklepu do własnych
                                                                potrzeb.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Dostęp do rosnącej liczby aplikacji
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                IdoSell Apps oferuje dostęp
                                                                aplikacji, które wspierają
                                                                merchantów na każdym etapie
                                                                działalności.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Szybka instalacja
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Instalowanie nowych aplikacji jest
                                                                łatwe i intuicyjne, co pozwala na
                                                                błyskawiczne wdrożenie nowych
                                                                funkcji.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Bezpłatne testowanie
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Przed zakupem możesz przetestować
                                                                aplikację, co minimalizuje ryzyko
                                                                nietrafionej inwestycji.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Integracja z zewnętrznymi
                                                                narzędziami
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                IdoSell Apps ułatwia połączenie z
                                                                zewnętrznymi systemami
                                                                sprzedażowymi, marketingowymi czy
                                                                księgowymi.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Regularne aktualizacje aplikacji
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Aplikacje dostępne w IdoSell Apps są
                                                                stale aktualizowane, co zapewnia
                                                                zgodność z dynamicznie zmieniającym
                                                                się rynkiem.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                        </Box>
                                        <CTASection
                                            title="Odkryj możliwości IdoSell"
                                            subtitle="Poznaj nasz panel, odkryj naszą technologię, otwórz lub migruj sklep i zacznij sprzedawać więcej."
                                            buttons={[
                                                {
                                                    title: 'Zamów sklep',
                                                    href: 'https://www.idosell.com/pl/abonamenty/',
                                                    variant: 'default',
                                                },
                                            ]}
                                        />
                                    </Box>
                                ),
                                imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=305543&ext=.webp',
                            },
                            {
                                tabName: 'Dla deweloperów',
                                content: (
                                    <Box>
                                        <Box
                                            background={'#1AAC7A'}
                                            padding={'50px 30px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column' }}
                                        >
                                            <Box width={'100%'}>
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                    color={'white'}
                                                    textAlign={'center'}
                                                >
                                                    Chcesz pisać aplikacje{' '}
                                                    <Box display={'inline'} color={'#171717'}>
                                                        dla 8 tys. sklepów IdoSell
                                                    </Box>{' '}
                                                    i zarabiać z nami?
                                                </Text>
                                                <Text
                                                    color={'#171717'}
                                                    fontSize={'18px'}
                                                    lineHeight={'27px'}
                                                    textAlign={'center'}
                                                >
                                                    Jesteś deweloperem, chcesz pisać aplikacje i na
                                                    tym zarabiać? Odkryj IdoSell Apps –platformę z
                                                    aplikacjami dla sklepów internetowych, która
                                                    umożliwia zewnętrznym deweloperom korzystanie z
                                                    otwartego API i tworzenie aplikacji
                                                    integrujących się z IdoSell.
                                                </Text>
                                            </Box>
                                            <Box
                                                width={'100%'}
                                                display={'grid'}
                                                gridTemplateColumns={{
                                                    base: '1fr',
                                                    md: 'repeat(4, 1fr);',
                                                }}
                                                gap={'20px'}
                                            >
                                                <Box
                                                    display={'flex'}
                                                    flexDirection={'column'}
                                                    alignItems={'center'}
                                                >
                                                    <Box
                                                        color={'#fff'}
                                                        fontSize={'54px'}
                                                        lineHeight={'69px'}
                                                        textAlign={'center'}
                                                        fontWeight={'600'}
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        alignItems={'flex-end'}
                                                    >
                                                        16
                                                        <Box
                                                            fontSize={'34px'}
                                                            lineHeight={'48px'}
                                                            marginBottom={'5px'}
                                                        >
                                                            mld zł
                                                        </Box>
                                                    </Box>
                                                    <Box textAlign={'center'} color={'#171717'}>
                                                        sumaryczna wartość transakcji rocznie (GMV)
                                                    </Box>
                                                </Box>
                                                <Box
                                                    display={'flex'}
                                                    flexDirection={'column'}
                                                    alignItems={'center'}
                                                >
                                                    <Box
                                                        color={'#fff'}
                                                        fontSize={'54px'}
                                                        lineHeight={'69px'}
                                                        textAlign={'center'}
                                                        fontWeight={'600'}
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        alignItems={'flex-end'}
                                                    >
                                                        ~8
                                                        <Box
                                                            fontSize={'34px'}
                                                            lineHeight={'48px'}
                                                            marginBottom={'5px'}
                                                        >
                                                            tys.
                                                        </Box>
                                                    </Box>
                                                    <Box textAlign={'center'} color={'#171717'}>
                                                        aktywnych sklepów internetowych
                                                    </Box>
                                                </Box>
                                                <Box
                                                    display={'flex'}
                                                    flexDirection={'column'}
                                                    alignItems={'center'}
                                                >
                                                    <Box
                                                        color={'#fff'}
                                                        fontSize={'54px'}
                                                        lineHeight={'69px'}
                                                        textAlign={'center'}
                                                        fontWeight={'600'}
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        alignItems={'flex-end'}
                                                    >
                                                        60
                                                        <Box
                                                            fontSize={'34px'}
                                                            lineHeight={'48px'}
                                                            marginBottom={'5px'}
                                                        >
                                                            mln
                                                        </Box>
                                                    </Box>
                                                    <Box textAlign={'center'} color={'#171717'}>
                                                        transkacji rocznie
                                                    </Box>
                                                </Box>
                                                <Box
                                                    display={'flex'}
                                                    flexDirection={'column'}
                                                    alignItems={'center'}
                                                >
                                                    <Box
                                                        color={'#fff'}
                                                        fontSize={'54px'}
                                                        lineHeight={'69px'}
                                                        textAlign={'center'}
                                                        fontWeight={'600'}
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        alignItems={'flex-end'}
                                                    >
                                                        24{' '}
                                                        <Box
                                                            fontSize={'34px'}
                                                            lineHeight={'48px'}
                                                            marginBottom={'5px'}
                                                        >
                                                            lata
                                                        </Box>
                                                    </Box>
                                                    <Box textAlign={'center'} color={'#171717'}>
                                                        doświadczenia w branży e-commerce
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box
                                            padding={{ base: '0px', md: '50px' }}
                                            marginTop={{ base: '20px', md: '0px' }}
                                            display={'flex'}
                                            flexDir={{ base: 'column', md: 'row' }}
                                            gap={{ base: '20px', md: '30px' }}
                                            alignItems={'center'}
                                        >
                                            <Box
                                                width={{ base: '100%', lg: '50%' }}
                                                padding={'30ox'}
                                            >
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                    color={'#171717'}
                                                >
                                                    Funkcjonalności dla deweloperów
                                                </Text>
                                                <List
                                                    spacing={'15px'}
                                                    fontSize={'18px'}
                                                    lineHeight={'27px'}
                                                >
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Dostęp do otwartego API
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Umożliwia tworzenie aplikacji i
                                                                integracji z platformą IdoSell.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Panel deweloperski
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Intuicyjny interfejs ułatwia
                                                                zarządzanie aplikacjami.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Dokumentacja API i wsparcie
                                                                techniczne
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Dostęp do szczegółowej dokumentacji
                                                                API oraz profesjonalnego wsparcia
                                                                technicznego.
                                                            </Text>
                                                            <Link
                                                                textDecoration={'underline'}
                                                                _hover={{ textDecoration: 'none' }}
                                                                target="_blank"
                                                                href="https://idosell.readme.io/docs/getting-started"
                                                            >
                                                                Dokumentacja IdoSell API
                                                            </Link>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Automatyczne rozliczenia
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Rozliczeniem subskrypcji zajmuje się
                                                                IdoSell, co oznacza, że deweloperzy
                                                                nie muszą się o to martwić.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                            <Box
                                                width={{ base: '100%', lg: '50%' }}
                                                display={'flex'}
                                            >
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=589915&ext=.png"
                                                    alt=""
                                                ></Image>
                                            </Box>
                                        </Box>
                                        <Box
                                            padding={{ base: '0px', md: '50px' }}
                                            display={'flex'}
                                            gap={{ base: '20px', md: '30px' }}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column-reverse', lg: 'row' }}
                                        >
                                            <Box
                                                width={{ base: '100%', lg: '50%' }}
                                                display={'flex'}
                                                justifyContent={'center'}
                                            >
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=589947&ext=.png"
                                                    alt=""
                                                ></Image>
                                            </Box>
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    Najważniejsze korzyści dla deweloperów
                                                </Text>
                                                <List
                                                    spacing={'15px'}
                                                    fontSize={'18px'}
                                                    lineHeight={'27px'}
                                                >
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Ponad 8 tysięcy sklepów
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                IdoSell Apps to ogromna szansa na
                                                                dotarcie do szerokiego grona
                                                                sprzedawców, którzy poszukują
                                                                innowacyjnych rozwiązań.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Atrakcyjny model współpracy
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Dzięki korzystnym warunkom
                                                                komercyjnym, deweloperzy mogą
                                                                zarabiać na sprzedaży swoich
                                                                aplikacji, jednocześnie rozwijając
                                                                swoją działalność.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                        </Box>
                                        <FormSection
                                            sectionTitle="Skontaktuj się z nami"
                                            sectionSubtitle="Masz pomysł na aplikacje i chcesz dowiedzieć się jak rozpocząć współpracę? Skontaktuj się z nami."
                                            region="eu1"
                                            portalId="26134891"
                                            formId="a2dfc841-6974-44aa-947d-651e8fcbe6b1"
                                        />
                                    </Box>
                                ),
                                imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=305544&ext=.jpeg',
                            },
                        ]}
                        activeTab={activeTab}
                        onTabChange={handleTabChange}
                    />
                </Box>
                <Box
                    position={'relative'}
                    id="apps_container"
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    _before={{
                        base: {
                            content: '""',
                            position: 'absolute',
                            height: '100%',
                            top: '0px',
                            width: '100vw',
                            marginLeft: '50%',
                            left: '-50vw',
                            zIndex: -2,
                            backgroundColor: 'rgba(238, 238, 238, 1)',
                        },
                    }}
                >
                    <Box
                        display={'flex'}
                        flexDirection={'column'}
                        gap={'10px'}
                        textAlign={'center'}
                        alignItems={'center'}
                    >
                        <Text fontSize={'34px'} lineHeight={'48px'} fontWeight={'600'}>
                            Aplikacje dostępne w IdoSell Apps
                        </Text>
                        <Text fontSize={'18px'} lineHeight={'27px'} fontWeight={'400'}>
                            Sprawdź co przygotowali deweloperzy dla Twojego sklepu
                        </Text>
                    </Box>
                    <Box>
                        <Box
                            display={'grid'}
                            gridTemplateColumns={{ base: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }}
                            padding={{ base: '35px 0px 35px', md: '50px 15px' }}
                            gap={{ base: '20px', md: '30px' }}
                        >
                            {displayedApps.map(app => (
                                <Box
                                    backgroundColor={'#fff'}
                                    padding={{ base: '16px', md: '25px' }}
                                    _hover={{
                                        boxShadow: '0px 12px 25px 0px #00000033',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => handleBoxClick(app)}
                                    key={app.id}
                                    role="group"
                                >
                                    <Box marginBottom={'16px'}>
                                        <Box
                                            padding={'8px'}
                                            boxShadow={'0px 4px 4px 0px #00000026'}
                                            width={'80px'}
                                            height={'80px'}
                                            _groupHover={{ transform: 'translateY(-10px)' }}
                                            transition="transform 0.2s ease-in-out"
                                            display={'flex'}
                                            alignItems={'center'}
                                        >
                                            <Image src={app?.image.url} alt={app?.image?.alt} />
                                        </Box>
                                    </Box>
                                    <Box
                                        display={'flex'}
                                        flexDirection={'column'}
                                        justifyContent={'space-between'}
                                    >
                                        <Box
                                            marginBottom={{ base: '30px', md: '0' }}
                                            height={{ base: '143px', md: '183px' }}
                                        >
                                            <Text
                                                fontSize={{ base: '14px', md: '21px' }}
                                                fontWeight={'600'}
                                                lineHeight={'1.4'}
                                                marginBottom={'10px'}
                                            >
                                                {app.title}
                                            </Text>
                                            <Text
                                                fontSize={'12px'}
                                                fontWeight={'400'}
                                                lineHeight={'19px'}
                                            >
                                                {app.description}
                                            </Text>
                                        </Box>
                                        <Box
                                            display={'flex'}
                                            alignItems={'center'}
                                            gap={'10px'}
                                            justifyContent={'space-between'}
                                        >
                                            <Box
                                                display={'flex'}
                                                flexDirection={{ base: 'column', md: 'row' }}
                                                alignItems={'center'}
                                                gap={{ base: '0', md: '10px' }}
                                            >
                                                <Text
                                                    color={'#171717'}
                                                    fontWeight={'600'}
                                                    fontSize={{ base: '16px', md: '18px' }}
                                                    lineHeight={{ base: '24px', md: '27px' }}
                                                >
                                                    {app.price.value}
                                                </Text>
                                                <Text
                                                    color={'#171717'}
                                                    fontSize={'12px'}
                                                    lineHeight={'19px'}
                                                    width={{ base: '100%', md: 'auto' }}
                                                >
                                                    {app.price.adding}
                                                </Text>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                        {apps.length > 8 && (
                            <Button
                                onClick={toggleShowAll}
                                fontSize={'16px'}
                                fontWeight={'600'}
                                lineHeight={'21px'}
                                textAlign={'center'}
                                textDecoration={'underline'}
                                background={'none'}
                                width={'100%'}
                                _hover={{
                                    background: 'none',
                                    textDecoration: 'none',
                                }}
                                marginTop={'0'}
                            >
                                {showAll ? 'Pokaż mniej' : 'Pokaż więcej'}
                            </Button>
                        )}
                    </Box>
                </Box>
                <ContentImage
                    title="Dlaczego IdoSell Apps wyprzedza konkurencję?"
                    image={{
                        url: 'https://www.idosell.com/panel/file-gate.php?id=589843&ext=.png',
                        alt: 'Zdjęcie marketplace',
                    }}
                    layout_order="image_left"
                    padding="3rem 0 3rem 0"
                    bgColor="grey"
                    mt={10}
                    // pt={{
                    //     base: 10,
                    //     lg: 8,
                    // }}
                >
                    <>
                        <p>
                            Jedną z ważniejszych przewag IdoSell Apps nad konkurencyjnymi
                            platformami jest możliwość zastosowania elastycznego modelu rozliczeń za
                            aplikacje. 
                        </p>
                        <p>
                            Dostęp do IdoSell Apps dla merchantów jest bezpłatny, natomiast koszty
                            są naliczane osobno za każdą uruchomioną aplikację, na zasadzie
                            subskrypcji miesięcznej. Cena aplikacji jest ustalana przez jej
                            dewelopera, co umożliwia zróżnicowane oferty dostosowane do potrzeb
                            sklepów internetowych. Dodatkowo, możliwość darmowego testowania
                            aplikacji, minimalizuje ryzyko związane z inwestycjami w nowe narzędzia.
                        </p>
                    </>
                </ContentImage>
                <ContactSection mb={'50px'} />

                {/* Modal Popup */}
                <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
                    <ModalOverlay />
                    <ModalContent padding="30px">
                        <ModalCloseButton />
                        <ModalBody padding={0}>
                            <Flex flexDirection={'column'}>
                                <Box
                                    padding={'8px'}
                                    boxShadow={'0px 4px 4px 0px #00000026'}
                                    width={'80px'}
                                    height={'80px'}
                                    marginBottom={'38px'}
                                >
                                    <Image
                                        src={selectedProduct?.image.url}
                                        alt={selectedProduct?.image?.alt}
                                    />
                                </Box>
                                <Grid
                                    gridTemplateColumns={{ base: '1fr', md: '2fr 1fr' }}
                                    gap={'45px'}
                                >
                                    <Box>
                                        <Text
                                            fontSize={{ base: '28px', md: '34px' }}
                                            fontWeight={'600'}
                                            lineHeight={'1.4'}
                                            marginBottom={'10px'}
                                        >
                                            {selectedProduct?.title}
                                        </Text>
                                        <Text
                                            fontSize={{ base: '14px', md: '16px' }}
                                            fontWeight={'400'}
                                            lineHeight={'1.4'}
                                            marginBottom={'45px'}
                                        >
                                            {selectedProduct?.description}
                                        </Text>
                                        <Grid
                                            gridTemplateColumns={'repeat(3, 1fr)'}
                                            marginBottom={'45px'}
                                            height={'150px'}
                                            gap={'10px'}
                                        >
                                            {selectedProduct?.images &&
                                                selectedProduct.images.map(image => (
                                                    <img
                                                        key={image.url}
                                                        src={image.url}
                                                        alt={image.alt}
                                                    />
                                                ))}
                                        </Grid>
                                        <Box
                                            display={'flex'}
                                            flexDir={'column'}
                                            gap={'20px'}
                                            fontSize={'16px'}
                                            lineHeight={'1.33'}
                                        >
                                            {selectedProduct?.longDescription}
                                        </Box>
                                    </Box>
                                    <Box display={'flex'} flexDirection={'column'}>
                                        <Box
                                            padding={'20px'}
                                            border={'4px solid rgba(238, 238, 238, 1)'}
                                        >
                                            <Text
                                                fontSize={{ base: '18px', md: '26px' }}
                                                fontWeight={'600'}
                                                lineHeight={'1.4'}
                                            >
                                                {selectedProduct?.price.value}
                                            </Text>
                                            <Text
                                                fontSize={{ base: '14px', md: '16px' }}
                                                fontWeight={'300'}
                                                lineHeight={'1.4'}
                                                marginBottom={'20px'}
                                            >
                                                {selectedProduct?.price.adding}
                                            </Text>
                                            <Link
                                                href="https://www.idosell.com/pl/dashboard/"
                                                target="_blank"
                                                display={'block'}
                                                background={'#171717'}
                                                color={'white'}
                                                padding={'10px 20px'}
                                                marginBottom={'20px'}
                                                textAlign={'center'}
                                                _hover={{
                                                    textDecoration: 'none',
                                                    color: 'white',
                                                }}
                                            >
                                                Dowiedz się więcej
                                            </Link>
                                            <Flex marginBottom={'20px'} flexDir={'column'}>
                                                <Text
                                                    fontSize={'12px'}
                                                    lineHeight={'1.3'}
                                                    fontWeight={'700'}
                                                    marginBottom={'5px'}
                                                >
                                                    Rodzaj aplikacji
                                                </Text>
                                                <Text fontSize="12px" lineHeight="1.3">
                                                    {selectedProduct?.app_type?.length ? (
                                                        selectedProduct.app_type.map(type => (
                                                            <Box
                                                                key={type}
                                                                display="flex"
                                                                alignItems="center"
                                                            >
                                                                {renderAppTypeIcon(type)}
                                                            </Box>
                                                        ))
                                                    ) : (
                                                        <Text>Brak dostępnych typów</Text>
                                                    )}
                                                </Text>
                                            </Flex>
                                            <Flex marginBottom={'20px'} flexDir={'column'}>
                                                <Text
                                                    fontSize={'12px'}
                                                    lineHeight={'1.3'}
                                                    fontWeight={'700'}
                                                    marginBottom={'5px'}
                                                >
                                                    Rodzaj licencji
                                                </Text>
                                                <Text fontSize="12px" lineHeight="1.3">
                                                    {selectedProduct?.license}
                                                </Text>
                                            </Flex>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Flex>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </div>
        </ThemeProvider>
    );
}
